import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import { LeaderBoardRank } from '@/models/LeaderBoardRank';

import { BaseFilters } from '@/models/Service';

export type ListKlassLeaderboardFilters = BaseFilters;

export async function listKlassLeaderBoard(
  klassId: number,
  filters: ListKlassLeaderboardFilters = {},
) {
  const { data } = await requester().get<JsonApiResponse<LeaderBoardRank>>(
    `analytics/klass-leaderboard/${klassId}/`,
    { params: filters },
  );

  return data;
}
